import moment from "moment";
import { _CasteData, _GenderData, _NationalityData } from "./common";
import { Religions } from "./options";

export const checkValidNationality = (nationality) => {
    if (!nationality || typeof nationality !== "string") {
        return { isValid: false, error: "Nationality is not provided or invalid." };
    }
    const trimmedNationality = nationality.trim().toLowerCase();
    const isValidNationality = _NationalityData.some(
        (n) => n.value.trim().toLowerCase() === trimmedNationality
    );
    if (!isValidNationality) {
        const validValues = _NationalityData.map(n => n.value).join(", ");
        return {
            isValid: false,
            error: `Nationality must be one of: ${validValues}.`,
        };
    }

    return { isValid: true };
};

export const validateEmail = (email) => {
    if (!email || typeof email !== "string") {
        return false;
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const trimmedEmail = email.trim(); // Remove any leading/trailing spaces
    return emailRegex.test(trimmedEmail);
};

export const checkValidReligion = (religion) => {
    if (!religion || typeof religion !== "string") {
        return { isValid: false, error: "Religion is not provided or invalid." };
    }

    const trimmedReligion = religion.trim().toLowerCase();

    const isValidReligion = Religions.some(
        (r) => r.value.trim().toLowerCase() === trimmedReligion
    );

    if (!isValidReligion) {
        const validValues = Religions.map(r => r.value).join(", ");
        return {
            isValid: false,
            error: `Religion must be one of: ${validValues}.`,
        };
    }

    return { isValid: true };
};


export const checkValidCasteCategory = (caste) => {
    if (!caste || typeof caste !== "string") {
        return { isValid: false, error: "Caste category is not provided or invalid." };
    }

    const trimmedCaste = caste.trim().toLowerCase();

    const isValidCaste = _CasteData.some(
        (c) => c.value.trim().toLowerCase() === trimmedCaste
    );

    if (!isValidCaste) {
        const validValues = _CasteData.map(c => c.value).join(", ");
        return {
            isValid: false,
            error: `Caste category must be one of: ${validValues}.`,
        };
    }

    return { isValid: true };
};

export const checkValidGender = (gender) => {
    if (!gender || typeof gender !== "string") {
        return { isValid: false, error: "Gender is not provided or invalid." };
    }

    // Trim spaces and convert to lowercase for case-insensitive comparison
    const trimmedGender = gender.trim().toLowerCase();

    const isValidGender = _GenderData.some((g) => g.value.trim().toLowerCase() === trimmedGender);

    if (!isValidGender) {
        return { isValid: false, error: "Gender must be 'Male', 'Female', or 'Other'." };
    }

    return { isValid: true };
};

export const isValidDate = (dateStr) => {
    // Validate presence
    if (!dateStr) {
        return { isValid: false, error: "Date is not provided." };
    }

    // Check if the date format is YYYY-MM-DD using regex
    const dateFormatRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
    if (!dateFormatRegex.test(dateStr)) {
        return { isValid: false, error: "Invalid date format. Use YYYY-MM-DD." };
    }

    // Parse year, month, day from dateStr (YYYY-MM-DD)
    const [year, month, day] = dateStr.split("-").map(Number);

    // Create Date object with ISO format YYYY-MM-DD
    const parsedDate = new Date(`${year}-${month}-${day}`);

    // Check if the date is valid (e.g., not Feb 30)
    if (
        parsedDate.getFullYear() !== year ||
        parsedDate.getMonth() + 1 !== month ||
        parsedDate.getDate() !== day
    ) {
        return {
            isValid: false,
            error: `Date is not a valid calendar date: ${dateStr}`,
        };
    }

    return {
        isValid: true,
        parsedDate: dateStr,
    };
};

export function convertDateToYYYYMMDD(dateString) {
    const parsedDate = moment(dateString, "DD/MM/YYYY");
    if (parsedDate.isValid()) {
        return parsedDate.format("YYYY-MM-DD");
    } else {
        console.error(`Invalid date string: ${dateString}`);
        return null;
    }
}



